/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Actions_CancelInputs */

const es_components_upgrade_plan_modal_actions_cancel = /** @type {(inputs: Components_Upgrade_Plan_Modal_Actions_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const en_components_upgrade_plan_modal_actions_cancel = /** @type {(inputs: Components_Upgrade_Plan_Modal_Actions_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Components_Upgrade_Plan_Modal_Actions_CancelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_actions_cancel = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Actions_CancelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Actions_CancelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_actions_cancel(inputs)
	return en_components_upgrade_plan_modal_actions_cancel(inputs)
});
export { components_upgrade_plan_modal_actions_cancel as "components.upgrade_plan_modal.actions.cancel" }